import type { IIdentity } from "@/providers/auth-provider";

/**
 * Synthetic actor for scheduled (cron) runs — Tina's automated scheduler.
 * Mirrors the injected `integration-api-key`→"Tina" member used for
 * Tina-created events in /events, and reuses the same avatar asset. The id
 * "cron" matches the COALESCE sentinel emitted by the today-coverage SQL.
 */
export const CRON_IDENTITY: IIdentity = {
  id: "cron",
  displayName: "Cron",
  email: "cron@mood.com",
  photoUrl: "/tina-icon.png",
  adminMetadata: { role: "humanoid" },
};
